import PropTypes from "prop-types";
import ScreenContent from "../../../components/layout/ScreenContent";
import TitledHeaderWithSearch from "../../../components/layout/TitledHeaderWithSearch";

const TableClickthroughSection = ({
  title,
  children,
  quickFilter,
  setQuickFilter,
  endContent,
  sx,
}) => {
  return (
    <>
      <TitledHeaderWithSearch
        title={title}
        quickFilter={quickFilter}
        setQuickFilter={setQuickFilter}
        endContent={endContent}
      />
      <ScreenContent
        sx={{
          display: "flex",
          flexDirection: "column",
          p: 0,
          ...sx,
        }}
      >
        {children}
      </ScreenContent>
    </>
  );
};

TableClickthroughSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  quickFilter: PropTypes.string,
  setQuickFilter: PropTypes.func,
  endContent: PropTypes.node,
  sx: PropTypes.object,
};

export default TableClickthroughSection;
